import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IOfferSchema, IUserSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import { IContext, IState } from '../../../../store';
import { addAdFoxBanner } from '../../index';
import { getRailwayAndHighwaysPuids } from '../../../../utils/adfox';

interface ITgbBannerStoreProps {
  offer: IOfferSchema;
  user: IUserSchema | null;
}

export interface ITgbBannerOwnProps {
  key: string;
  randomId: string;
  positionInfo: string;
  className?: string;
}

interface ITgbBannerProps extends ITgbBannerStoreProps, ITgbBannerOwnProps {}

const banner: React.StatelessComponent<ITgbBannerProps> = (props: ITgbBannerProps, context: IContext) =>
  addAdFoxBanner({
    type: 'seo',
    key: props.key,
    makeRequest: context.makeRequest,
    offer: props.offer,
    randomId: props.randomId,
    positionInfo: props.positionInfo,
    isAgent: !!props.user && !!props.user.isAgent,
    className: props.className,
    additionalPuids: getRailwayAndHighwaysPuids(props.offer),
  });

banner.contextTypes = {
  makeRequest: PropTypes.func,
};

function mapStateToProps(state: IState): ITgbBannerStoreProps {
  return {
    offer: state.offerData.offer,
    user: state.offerData.user,
  };
}

export const TgbBannerContainer = connect<ITgbBannerStoreProps, {}, ITgbBannerOwnProps>(mapStateToProps)(banner);
